<template>
    <div
        v-if="open"
        class="fixed inset-0 top-[64px] z-40"
        @click="closeSidebar"
    />
    <div
        :class="[
            'fixed top-[64px] z-50 flex h-[calc(100vh-64px)] w-1/3 flex-col items-start justify-start border-l border-gray-200 bg-white transition-all duration-500',
            {
                '-right-full': !open,
                'right-0': open,
            },
        ]"
    >
        <div
            class="flex w-full shrink-0 items-center justify-between border-b border-gray-200 p-4"
        >
            <div class="flex h-auto w-auto items-center justify-center">
                <fa
                    icon="fa-close"
                    class="cursor-pointer text-2xl text-gray-300 duration-200 hover:text-gray-400"
                    @click="closeSidebar"
                />
            </div>
            <div
                class="flex h-auto w-auto space-x-1 rounded-lg bg-slate-200 p-1"
            >
                <div
                    v-for="section in sections"
                    :key="section.value"
                    :class="[
                        'h-auto w-auto cursor-pointer rounded-md px-4 py-1 text-xs uppercase',
                        activeSection === section.value
                            ? 'bg-slate-100'
                            : 'bg-transparent',
                    ]"
                    @click="activeSection = section.value"
                >
                    {{ section.name }}
                </div>
            </div>
        </div>
        <div class="w-full flex-1 overflow-y-auto">
            <PageBuilderSidebarBlocksSection
                v-show="activeSection === 'blocks'"
            />
            <PageBuilderSidebarSeoSection
                v-show="activeSection === 'seo'"
                :active-locale="activeLocale"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import PageBuilderSidebarBlocksSection from './PageBuilderSidebarBlocksSection.vue'
import PageBuilderSidebarSeoSection from './PageBuilderSidebarSeoSection.vue'
import { SUPPORTED_LOCALES } from '@builder/defaults'

defineProps<{
    open: boolean
    activeLocale: (typeof SUPPORTED_LOCALES)[number]
}>()

const emit = defineEmits(['close'])

const activeSection = ref<'seo' | 'blocks'>('blocks')
const sections = ref<{ name: string; value: 'seo' | 'blocks' }[]>([
    { name: 'SEO', value: 'seo' },
    { name: 'Blocks', value: 'blocks' },
])

const closeSidebar = () => {
    emit('close')
}
</script>
